import $ from 'jquery';
import Breakpoint from '../01-helpers/breakpoint-util';

const selectors = {
    newsContainer: '.js-news-list-container',
    newsList: '.js-news-list',
    newsItems: '.js-news-item',
    moreNews: '.c-link',
	showMore: '.c-button',
	buttoncontainer: '.o-button-container'
};

const minItems = 5,
    maxItems = 8;

/** 
 * Show more news acticles on button click 
 **/
export default class NewsList {
    constructor(elm) {
        this.$container = $(elm);
        this.$newsItems = this.$container.find(selectors.newsList).find(selectors.newsItems);
		this.$showMore = this.$container.find(selectors.showMore);
		this.$buttonContainer = this.$container.find(selectors.buttoncontainer);
        this.$moreNews = this.$container.find(selectors.moreNews);
        this.init();
    }

    init() {
        this.registerHandlers();
        this.onBreakpointChanged();
    }

    registerHandlers() {
        this.$showMore.on('click', e => this.onShowMore(e));
        $(window).on('breakpointChange.newslist', this.onBreakpointChanged.bind(this));
    }

    expandList() {
        this.showNewsItems(maxItems);
		this.hideElement(this.$showMore);
		this.hideElement(this.$buttonContainer);
        this.showElement(this.$moreNews);
    }

    collapseList() {
        this.showNewsItems(minItems);
		this.showElement(this.$showMore);
		this.showElement(this.$buttonContainer);
        this.hideElement(this.$moreNews);
    }

    /**
     * show give amount of news items.
     * @param {number} total amount of news items to show
     */
    showNewsItems(total) {
        $.each(this.$newsItems, (index, item) => {
            if (index >= total) {
                this.hideElement(item);
            } else {
                this.showElement(item);
            }
        })
    }

    /**
     * hide given element
     * @param {Element} elm
     */
    hideElement(elm) {
        $(elm).addClass('hidden');
    }

    /**
     * show given element
     * @param {Element} elm
     */
    showElement(elm) {
        $(elm).removeClass('hidden');
    }

    /**
     * show all news items
     * @param {any} event
     */
    onShowMore(event) {
        event.preventDefault();
        this.showNewsItems(maxItems);
        this.showElement(this.$moreNews);
		this.hideElement(this.$showMore);
		this.hideElement(this.$buttonContainer);
    }

    /**
     * When viewport changes, collapse newslist on mobile devices.
     */
    onBreakpointChanged() {
        this.expandList();
        if (Breakpoint.isPalm()) {
            this.collapseList();
        }
    }
}

/*
 * search for all js-equal-article-height classes in the project and apply this module.
 */
$(selectors.newsContainer).each(function () {
    new NewsList(this);
});  
